import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthPage from "./pages/auth/authPage/AuthPage"
import CropsDetailedPage from "@pages/dashboard/crops/detalization"
import ExpensesDetailedPage from "@pages/dashboard/expenses/detalization"
import WorksDetailedPage from "@pages/dashboard/works/detalization"
import DashboardPageContainer from "@pages/dashboard/DashboardPage";
import MapPage from "./pages/monitoring/map/MapPage";
import ListUnits from "./pages/monitoring/units/listUnits/ListUnits";
import DetailsUnit from "./pages/monitoring/units/detailsUnit/DetailsUnit";
import DetailsField from "./pages/monitoring/fields/detailsField/DetailsField";
import EditField from "./pages/monitoring/fields/editField/EditField";
import ListFields from "./pages/monitoring/fields/listFields/ListFields";
import ReferencesPageContainer from "@pages/references/ReferencesPageContainer";
import ReportsPageContainer from "@pages/reports/ReportsPageContainer";
import PlanPageContainer from "@pages/plan/PlanPageContainer";
import BudgetPageContainer from "@pages/budget/BudgetPageContainer";
import NotificationsPageContainer from "@pages/notifications/NotificationsPageContainer";
import UserPageContainer from "@pages/user/UserPageContainer";
import StateCropsDetailedPage from "@pages/dashboard/statecrops/detalization";
import logger from "@utils/logger";
import { RootState } from "./store";
import LoadingBox from "@elements/loading/LoadingBox";
import { Authorized } from "@infobis/as-react-auth";
import { createSelector } from "@reduxjs/toolkit";
import Drones from "@pages/partners/items/drones/Drones";
import PartnersPage from "@pages/partners/PartnersPage";
import Uralchem from "@pages/partners/items/uralchem/Uralchem";
import WorksByDepartmentsAndCropsPage from '@pages/dashboard/works/byDepartmentsAndCrops';

const log = logger.getLogger("private")
export const AuthSelector = createSelector((state: RootState) => state, x => x.auth)

const AuthorizedRoute = Authorized({
    onLoading: () => <LoadingBox />,
    onUnauthorized: () => <Navigate replace to={"/login"}/>,
    selector: AuthSelector,
    checkOrganization: true
})


export const DashboardRoutes = () => {
    return <Routes>
        <Route index element={<AuthorizedRoute component={DashboardPageContainer}/>}/>
        <Route path={"crops"} element={<AuthorizedRoute component={CropsDetailedPage}/>}/>
        <Route path={"crops-states"} element={<AuthorizedRoute component={StateCropsDetailedPage}/>}/>
        <Route path={"expenses"}>
            <Route index element={<Navigate replace to="0"/>}/>
            <Route path={":monthId"} element={<AuthorizedRoute component={ExpensesDetailedPage}/>}/>
        </Route>
        <Route path={"work"}>
            <Route path={"detailing/:workId"} element={<AuthorizedRoute component={WorksDetailedPage}/>}/>
            <Route path={"by-departments-and-crops"} element={<AuthorizedRoute component={WorksByDepartmentsAndCropsPage} />} />
        </Route>
        <Route path={"login"} element={<AuthPage/>}/>
        <Route path="*" element={<>not found</>}/>
    </Routes>
}

export const PartnersRoutes = () => {
    return <Routes>
        <Route index element={<AuthorizedRoute component={PartnersPage}/>}/>
        <Route path={"drones"} element={<AuthorizedRoute component={Drones}/>}/>
        <Route path={"uralchem"} element={<AuthorizedRoute component={Uralchem}/>}/>
        <Route path={"login"} element={<AuthPage/>}/>
        <Route path="*" element={<>not found</>}/>
    </Routes>
}

const CustomRoutes = () => {
    return (
        <Routes>
            <Route path={"/"}>
                <Route index element={<Navigate to={"map"}/>}/>
                <Route path={"map"} element={<AuthorizedRoute component={MapPage}/>}>
                    <Route index element={<Navigate replace to={"fields"}/>}/>
                    <Route path={"fields"}>
                        <Route index element={<AuthorizedRoute component={ListFields}/>}/>
                        <Route path={":fieldId"}>
                            <Route index element={<Navigate replace to={"details"}/>}/>
                            <Route path={"details"} element={<AuthorizedRoute component={DetailsField}/>}/>
                            <Route path={"edit"} element={<AuthorizedRoute component={EditField}/>}/>
                        </Route>
                    </Route>
                    <Route path={"units"}>
                        <Route index element={<AuthorizedRoute component={ListUnits}/>}/>
                        <Route path={":unitId"}>
                            <Route index element={<Navigate replace to={"details"}/>}/>
                            <Route path={"details"} element={<AuthorizedRoute component={DetailsUnit}/>}/>
                            <Route path={"edit"} element={<AuthorizedRoute component={DetailsUnit}/>}/>
                        </Route>
                    </Route>
                </Route>

                <Route path={"references"}>
                    <Route index element={<AuthorizedRoute component={ReferencesPageContainer}/>}/>
                </Route>

                <Route path={"reports"}>
                    <Route index element={<AuthorizedRoute component={ReportsPageContainer}/>}/>
                </Route>

                <Route path={"plan"}>
                    <Route index element={<AuthorizedRoute component={PlanPageContainer}/>}/>
                </Route>

                <Route path={"budget"}>
                    <Route index element={<AuthorizedRoute component={BudgetPageContainer}/>}/>
                </Route>

                <Route path={"notifications"}>
                    <Route index element={<AuthorizedRoute component={NotificationsPageContainer}/>}/>
                </Route>

                <Route path={"user"}>
                    <Route index element={<AuthorizedRoute component={UserPageContainer}/>}/>
                </Route>

                <Route path={"dashboards"}>
                    <Route index element={<AuthorizedRoute component={DashboardPageContainer}/>}/>
                    <Route path={"crops"} element={<AuthorizedRoute component={CropsDetailedPage}/>}/>
                    <Route path={"crops-states"} element={<AuthorizedRoute component={StateCropsDetailedPage}/>}/>
                    <Route path={"expenses"}>
                        <Route index element={<Navigate replace to="0"/>}/>
                        <Route path={":monthId"} element={<AuthorizedRoute component={ExpensesDetailedPage}/>}/>
                    </Route>
                    <Route path={"work"}>
                        <Route path={"detailing/:workId"} element={<AuthorizedRoute component={WorksDetailedPage}/>}/>
                        <Route path={"by-departments-and-crops"} element={<AuthorizedRoute component={WorksByDepartmentsAndCropsPage} />} />
                    </Route>
                </Route>

                <Route path={"partner"}>
                    <Route index element={<AuthorizedRoute component={PartnersPage}/>}/>
                    <Route path={"drones"} element={<AuthorizedRoute component={Drones}/>}/>
                    <Route path={"uralchem"} element={<AuthorizedRoute component={Uralchem}/>}/>
                </Route>

                <Route path={"login"} element={<AuthPage/>}/>
                <Route path="*" element={<>not found</>}/>
            </Route>

        </Routes>
    )
}
export { CustomRoutes };